export const SUBSCRIBE_PATH = "https://checkout.ens.edu.br/portal/#/inscricao/cadastro" 
export const INTEREST_DEFAULT_LINK = "https://www.ens.edu.br/cursos/inscricoes-de-interesse" 
export const PARTNER_ID = 1